module.exports = __webpack_public_path__ + "img/Vector 4.b0375802.svg";